// src/components/Navbar.jsx
import React, { useEffect, useState, useRef } from 'react';
import './Navbar.css';

const sectionColors = {
  hi: '#9FCCD1',
  vision: '#EE9CA9',
  past: '#F4C98B',
  present: '#B5D7B4',
  showcase: '#D0A9CF',
  future: '#F6B793'
};

// GECORRIGEERD: Future en Showcase omgewisseld in de data-array
const menuItems = [
  { name: 'Hi!', id: 'hi', colorKey: 'hi' },
  { name: 'Vision & identity', id: 'visionidentity', colorKey: 'vision' },
  { name: 'Past', id: 'past', colorKey: 'past' },
  { name: 'Present', id: 'present', colorKey: 'present' },
  { name: 'Future', id: 'future', colorKey: 'future' },
  { name: 'Showcase', id: 'showcase', colorKey: 'showcase' }
];

export default function Navbar({ activeSectionProp, forcedScrollProgress, onLogoClick }) {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [activeSection, setActiveSection] = useState('hi');
  const [pathLength, setPathLength] = useState(0);
  const pathRef = useRef(null);

  useEffect(() => {
    if (pathRef.current) {
      setPathLength(pathRef.current.getTotalLength());
    }

    if (activeSectionProp) return;

    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
          if (totalHeight > 0) {
            setScrollProgress(window.scrollY / totalHeight);
          }

          const vh = window.innerHeight;
          
          const customThresholds = {
            hi: vh * .5,
            visionidentity: vh * 0.35, 
            past: vh * 0.5,            
            present: vh * .9,         
            future: vh * 0.65,       
            showcase: vh * 0.70          
          };

          let currentActive = 'hi';
          // GECORRIGEERD: De volgorde van scroll-controle matcht nu de visuele volgorde
          const checkOrder = ['showcase', 'future', 'present', 'past', 'visionidentity', 'hi'];
          
          for (const id of checkOrder) {
            const el = document.getElementById(id);
            if (el) {
              const rect = el.getBoundingClientRect();
              const triggerPoint = customThresholds[id] || (vh * 0.5);
              
              if (rect.top <= triggerPoint) {
                const matched = menuItems.find(item => item.id === id);
                if (matched) {
                  currentActive = matched.colorKey;
                  break;
                }
              }
            }
          }
          
          setActiveSection(currentActive);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [activeSectionProp]);

  const currentActiveSection = activeSectionProp || activeSection;
  const currentScrollProgress = forcedScrollProgress !== undefined ? forcedScrollProgress : scrollProgress;

  const CollegeExponent = 0.75;
  const easedProgress = Math.pow(currentScrollProgress, CollegeExponent);

  const currentOffset = pathLength - (easedProgress * pathLength);
  const currentActiveColor = sectionColors[currentActiveSection] || '#1a1a1a';

  const scrollToSection = (id) => {
    if (activeSectionProp && onLogoClick) {
      onLogoClick();
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 50);
      return;
    }

    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="navbar-fixed-header-container">
      <div className="navbar-inner-550">
        
        <img 
          src="/images/Navbar/Navbar_border.png" 
          alt="Navbar Custom Border" 
          className="navbar-border-shadow" 
        />

        {/* DYNAMISCHE SCRIBBLER SVG (Geometrie aangepast naar Future -> Showcase transitie) */}
        <svg className="navbar-scribble-svg" viewBox="0 0 550 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            ref={pathRef}
            className="navbar-scribble-path"
            d="M 8,48 
               C -15,15 48,5 42,42 
               C 35,72 -5,68 18,52
               C 40,35 60,20 110,20 
               C 165,20 170,55 210,55
               C 225,55 224,30 242,30
               C 262,30 266,58 248,58
               C 230,58 234,30 262,30
               C 292,30 300,58 340,58
               C 365,58 380,38 410,38
               C 435,38 430,62 405,62
               C 385,62 390,15 440,15
               C 495,15 542,12 510,48
               C 485,75 442,48 545,46"
            stroke={currentActiveColor}
            strokeWidth="2.3"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
              strokeDasharray: pathLength,
              strokeDashoffset: currentOffset,
            }}
          />
        </svg>

        <nav className="navbar-links-layer">
          {menuItems.map((item) => {
            const isSelected = currentActiveSection === item.colorKey;
            return (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`nav-item ${isSelected ? 'is-active' : ''}`}
                style={isSelected ? { color: item.colorKey === 'hi' ? '#55B947' : currentActiveColor } : {}}
              >
                {item.name}
              </button>
            );
          })}
        </nav>

      </div>
    </header>
  );
}